import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * Main application shell with header, sidebar, and content area.
 * Following DESIGN-SYSTEM.md layout patterns.
 */
export function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <Header />

      <div className="flex flex-1">
        <Sidebar />

        <main id="main-content" className="flex-1 p-6 bg-background overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
